document.documentElement.classList.add('js');

(function(){
  const g = document.createElement('div');
  g.className = 'grain-overlay';
  document.body.appendChild(g);
})();

(function(){
  const navIn = document.querySelector('.nav-in');
  if (!navIn) return;
  const sync = () => navIn.classList.toggle('scrolled', window.scrollY > 12);
  window.addEventListener('scroll', sync, {passive:true});
  sync();
})();

(function(){
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const count = 140;
  const shadows = [];
  for (let i = 0; i < count; i++){
    const x = (Math.random() * 100).toFixed(2);
    const y = (Math.random() * 100).toFixed(2);
    const big = Math.random() < 0.12;
    const alpha = (0.35 + Math.random() * 0.65).toFixed(2);
    shadows.push(`${x}vw ${y}vh 0 ${big ? '1px' : '0px'} rgba(255,255,255,${alpha})`);
  }
  const field = document.createElement('div');
  field.className = 'starfield' + (reduceMotion ? '' : ' twinkle');
  field.style.boxShadow = shadows.join(',');
  document.body.appendChild(field);
})();

(function(){
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!finePointer || reduceMotion) return;

  const glow = document.createElement('div');
  glow.className = 'cursor-glow';
  document.body.appendChild(glow);

  let tx = 0, ty = 0, cx = 0, cy = 0, raf = null;

  function update(){
    cx += (tx - cx) * 0.18;
    cy += (ty - cy) * 0.18;
    glow.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
    if (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) {
      raf = requestAnimationFrame(update);
    } else {
      raf = null;
    }
  }

  window.addEventListener('mousemove', (e) => {
    tx = e.clientX; ty = e.clientY;
    if (!glow.classList.contains('active')) {
      cx = tx; cy = ty;
      glow.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      glow.classList.add('active');
    }
    if (!raf) raf = requestAnimationFrame(update);
  }, {passive:true});

  window.addEventListener('mouseleave', () => glow.classList.remove('active'));
})();

(function(){
  const burger = document.getElementById('navBurger');
  const menu = document.getElementById('navMobile');
  if (!burger || !menu) return;
  burger.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    menu.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
  }));
})();

(function(){
  const targets = document.querySelectorAll('.reveal');
  if (!targets.length) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
  }, {threshold:.1});
  targets.forEach(el => obs.observe(el));
  setTimeout(() => { targets.forEach(el => el.classList.add('in')); obs.disconnect(); }, 2200);
})();

document.querySelectorAll('.faq-btn').forEach(b => b.addEventListener('click', () => {
  const open = b.getAttribute('aria-expanded') === 'true';
  const panel = b.nextElementSibling;
  b.setAttribute('aria-expanded', String(!open));
  panel.style.height = open ? '0px' : panel.firstElementChild.offsetHeight + 'px';
}));

(function(){
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  function attachTilt(el, maxDeg){
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      const ry = (px - 0.5) * (maxDeg * 2);
      const rx = (0.5 - py) * (maxDeg * 2);
      el.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      el.style.setProperty('--ry', ry.toFixed(2) + 'deg');
    });
    el.addEventListener('pointerleave', () => {
      el.style.setProperty('--rx', '0deg');
      el.style.setProperty('--ry', '0deg');
    });
  }

  document.querySelectorAll('.gauge-wrap').forEach(c => attachTilt(c, 10));
  document.querySelectorAll('.tile').forEach(t => attachTilt(t, 6));
  document.querySelectorAll('.p-tile').forEach(t => attachTilt(t, 5));

  const layers = document.querySelectorAll('.spatial-layer');
  if (layers.length){
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      layers.forEach(l => {
        const depth = parseFloat(l.dataset.depth || '0.1');
        l.style.transform = `translateY(${y * depth}px)`;
      });
    }, {passive:true});
  }
})();

(function(){
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function angleForRisk(risk){
    const clamped = Math.max(0, Math.min(5, risk));
    return -120 + (clamped / 5) * 240;
  }

  function buildGauge(containerId, startAngle){
    const host = document.getElementById(containerId);
    if (!host) return null;
    host.innerHTML = `
      <svg viewBox="0 0 200 200" role="img" aria-label="Risk dial">
        <defs>
          <radialGradient id="${containerId}Face" cx="35%" cy="30%" r="75%">
            <stop offset="0%" stop-color="#2c2c30"/>
            <stop offset="100%" stop-color="#08080a"/>
          </radialGradient>
          <linearGradient id="${containerId}Rim" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#EBD39A"/>
            <stop offset="45%" stop-color="#C6A664"/>
            <stop offset="65%" stop-color="#6b5730"/>
            <stop offset="100%" stop-color="#EBD39A"/>
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="92" fill="url(#${containerId}Rim)"/>
        <circle cx="100" cy="100" r="86" fill="none" stroke="rgba(255,255,255,.18)" stroke-width="1"/>
        <circle cx="100" cy="100" r="82" fill="url(#${containerId}Face)"/>
        <ellipse cx="100" cy="66" rx="52" ry="26" fill="rgba(255,255,255,.05)"/>
        <g stroke="#C6A664" stroke-width="2.4" stroke-linecap="round" opacity="0.85">
          <line x1="32.5" y1="139.0" x2="42.8" y2="133.0"/>
          <line x1="25.8" y1="75.9" x2="37.2" y2="79.6"/>
          <line x1="68.3" y1="28.8" x2="73.2" y2="39.7"/>
          <line x1="131.7" y1="28.8" x2="126.8" y2="39.7"/>
          <line x1="174.2" y1="75.9" x2="162.8" y2="79.6"/>
          <line x1="167.6" y1="139.0" x2="157.2" y2="133.0"/>
        </g>
        <g font-family="'Space Mono', monospace" font-size="8" fill="#E4E3E7" opacity="0.45" text-anchor="middle">
          <text x="32.5" y="152">0%</text>
          <text x="100" y="22">2.5%</text>
          <text x="167.6" y="152">5%</text>
        </g>
        <line id="${containerId}Needle" x1="100" y1="100" x2="100" y2="32" stroke="#EBD39A" stroke-width="3" stroke-linecap="round" transform="rotate(${startAngle} 100 100)"/>
        <circle cx="100" cy="100" r="7" fill="url(#${containerId}Rim)"/>
        <text x="100" y="118" text-anchor="middle" font-family="'Space Mono', monospace" font-size="8" fill="#E4E3E7" opacity="0.5" letter-spacing="2">RISK</text>
      </svg>
    `;
    return host.querySelector(`#${containerId}Needle`);
  }

  const heroNeedle = buildGauge('heroGauge', angleForRisk(1));
  if (heroNeedle && !reduceMotion){
    let raf = null;
    function idle(t){
      const wobble = Math.sin(t * 0.0006) * 4;
      heroNeedle.setAttribute('transform', `rotate(${angleForRisk(1) + wobble} 100 100)`);
      raf = requestAnimationFrame(idle);
    }
    raf = requestAnimationFrame(idle);
  }

  const productNeedle = buildGauge('productGauge', angleForRisk(1));
  if (productNeedle){
    const riskInput = document.getElementById('risk');
    if (riskInput){
      const sync = () => {
        const v = parseFloat(riskInput.value) || 0;
        productNeedle.setAttribute('transform', `rotate(${angleForRisk(v)} 100 100)`);
      };
      riskInput.addEventListener('input', sync);
      sync();
    }
  }
})();

(function(){
  const out = document.getElementById('out');
  if (!out) return;
  const $ = id => document.getElementById(id);
  function recalc(){
    const bal = parseFloat($('bal').value) || 0;
    const risk = parseFloat($('risk').value) || 0;
    const entry = parseFloat($('entry').value) || 0;
    const stop = parseFloat($('stop').value) || 0;
    const perShare = Math.abs(entry - stop);
    const dollarsAtRisk = bal * (risk / 100);
    const size = perShare > 0 ? dollarsAtRisk / perShare : 0;
    $('out').textContent = size.toFixed(2);
    $('outRisk').textContent = dollarsAtRisk.toFixed(2) + ' SEK';
    $('outPer').textContent = perShare.toFixed(2) + ' SEK';
  }
  ['bal','risk','entry','stop'].forEach(id => $(id).addEventListener('input', recalc));
  recalc();
})();
